import Layout from '@/layout';
var couponRouter = {
  path: '/coupon',
  component: Layout,
  redirect: '/coupon/list',
  name: 'Coupon',
  meta: {
    title: '优惠券',
    icon: 'clipboard'
  },
  children: [{
    path: 'list/save',
    name: 'couponAdd',
    meta: {
      title: '优惠劵添加',
      noCache: true,
      activeMenu: "/coupon/list"
    },
    hidden: true,
    component: function component() {
      return import('@/views/coupon/list/creatCoupon');
    }
  }, {
    path: 'list/save/:id?',
    name: 'couponEdit',
    meta: {
      title: '优惠劵复制',
      noCache: true,
      activeMenu: "/coupon/list"
    },
    hidden: true,
    component: function component() {
      return import('@/views/coupon/list/creatCoupon');
    }
  }, {
    path: 'list/save/:id?/:edit?',
    name: 'couponEdit',
    meta: {
      title: '优惠劵编辑',
      noCache: true,
      activeMenu: "/coupon/list"
    },
    hidden: true,
    component: function component() {
      return import('@/views/coupon/list/creatCoupon');
    }
  }, {
    path: 'list',
    component: function component() {
      return import('@/views/coupon/list/index');
    },
    name: 'List',
    meta: {
      title: '优惠券列表',
      icon: ''
    }
  }, {
    path: 'record',
    component: function component() {
      return import('@/views/coupon/record/index');
    },
    name: 'Record',
    meta: {
      title: '领取记录',
      icon: ''
    }
  },
  // 平台优惠券（从平台端移入，同名文件加 mer 前缀）
  {
    path: 'merCouponList',
    component: function component() {
      return import('@/views/coupon/merCouponList/index');
    },
    name: 'MerCouponList',
    meta: {
      title: '平台优惠券',
      icon: ''
    }
  }, {
    path: 'merCouponList/merCreatCoupon',
    component: function component() {
      return import('@/views/coupon/merCouponList/merCreatCoupon');
    },
    name: 'MerCouponAdd',
    meta: {
      title: '添加平台优惠券',
      noCache: true,
      activeMenu: '/coupon/merCouponList'
    },
    hidden: true
  }, {
    path: 'merCouponList/merCreatCoupon/:id?',
    component: function component() {
      return import('@/views/coupon/merCouponList/merCreatCoupon');
    },
    name: 'MerCouponEdit',
    meta: {
      title: '编辑/复制平台优惠券',
      noCache: true,
      activeMenu: '/coupon/merCouponList'
    },
    hidden: true
  }, {
    path: 'merCouponList/merCreatCoupon/:id?/:copy?',
    component: function component() {
      return import('@/views/coupon/merCouponList/merCreatCoupon');
    },
    name: 'MerCouponCopy',
    meta: {
      title: '复制平台优惠券',
      noCache: true,
      activeMenu: '/coupon/merCouponList'
    },
    hidden: true
  }, {
    path: 'merCouponList/newGift',
    component: function component() {
      return import('@/views/coupon/merCouponList/newGift');
    },
    name: 'MerNewGift',
    meta: {
      title: '新人礼/生日礼',
      icon: ''
    }
  }, {
    path: 'merCouponRecord',
    component: function component() {
      return import('@/views/coupon/merCouponRecord/index');
    },
    name: 'MerCouponRecord',
    meta: {
      title: '平台优惠券领取记录',
      icon: ''
    }
  }]
};
export default couponRouter;